import { GridCellProps } from '@progress/kendo-react-grid';
import React, { VFC } from 'react';
import * as enums from '../../../../../enums';

interface IProps {
    device: string;
}

const DisplayTypeCell: VFC<GridCellProps & IProps> = ({ dataItem, device }) => {
    const formatEnumByDevice = (device: string) => {
        switch (device) {
            case 'infoScreen':
                return <td>{enums.infoScreenDisplayType.format(dataItem.displayType)}</td>;
            case 'doorScreen':
                return <td>{enums.doorScreenDisplayType.format(dataItem.displayType)}</td>;
            default:
                <td></td>;
        }

        return <td></td>;
    };

    return formatEnumByDevice(device);
};

export default DisplayTypeCell;
